import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ShareService } from 'src/app/services/share-service.service';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent {
  url = '';
  title = '';
  subject = '';
  body = '';

  @Output() closePopup = new EventEmitter<any>();

  constructor(private shareService: ShareService) {
    this.url = this.shareService.getUrl();
    this.title = this.shareService.getText();
    let body = this.shareService.getDescription();

    if (body) {
      this.body = body.slice(0, 125) + '...';
    }
  }

  share(platform: string) {
    switch (platform) {
      case 'facebook':
        this.shareService.shareOnFacebook(this.url);
        break;
      case 'twitter':
        this.shareService.shareOnTwitter(this.url, this.title);
        break;
      case 'linkedin':
        this.shareService.shareOnLinkedIn(this.url);
        break;
      case 'whatsapp':
        this.shareService.shareOnWhatsApp(this.url, this.title);
        break;
      case 'messenger':
        this.shareService.shareOnMessenger(this.url);
        break;
      case 'gmail':
        this.shareService.shareOnGmail(this.url, this.title, this.body);
        break;
      case 'instagram':
        this.shareService.shareOnInstagram(this.url);
        break;
      default:
        console.error('Unknown platform');
    }
  }

  close() {
    this.shareService.close()
  }
}

